export default [
    {
        path: 'journal/list',
        name: 'content_journal_list',
        meta: { isCache: true, icon: 'md-paper-plane', hideInMenu: false },
        component: () => import('@/views/content/journal/journal-list.vue'),
    },
    {
        path: 'journal/add',
        name: 'content_journal_add',
        meta: { isCache: false, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/content/journal/journal-add.vue'),
    },
    {
        path: 'journal/edit/:id',
        name: 'content_journal_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/content/journal/journal-edit.vue'),
    },
    {
        path: 'journal/detail/:id',
        name: 'content_journal_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/content/journal/journal-detail.vue'),
    },
];
